import { useQuery } from '@tanstack/react-query';
import { Endpoints } from '@xver/apis';
import type { ListCredentialsResponse } from '@xver/apis/v1/kufer/registry-credentials/model';

export const REGISTRY_CREDENTIALS_QUERY_KEY = ['apis.v1.kufer.registry-credentials.list'];

export function useRegistryCredentialsQuery() {
    return useQuery<ListCredentialsResponse>({
        queryKey: REGISTRY_CREDENTIALS_QUERY_KEY,
        queryFn: Endpoints.v1.Kufer.RegistryCredentials.listCredentials,
        staleTime: 30_000,
    });
}
